/* eslint-disable max-len */
import ShibQuestion from 'images/coin-pages/questions/shiba.svg'

import { ICoinPageData } from '../types'

export const shibPage: ICoinPageData = {
  title: 'coin_881',
  description: 'coin_882',
  questionsBlock: {
    image: ShibQuestion,
    questions: [
      {
        title: 'coin_883',
        answer: 'coin_884',
      },
      {
        title: 'coin_885',
        answer: 'coin_886',
      },
      {
        title: 'coin_887',
        answer: 'coin_888',
      },
      {
        title: 'coin_889',
        answer: 'coin_890',
      },
      {
        title: 'coin_891',
        answer: 'coin_892',
      },
    ],
  },
  whatIs: {
    text: [],
    paragraphs: [
      {
        title: 'coin_893',
        text: ['coin_897'],
      },
      {
        title: 'coin_894',
        text: ['coin_898'],
      },
      {
        title: 'coin_895',
        text: ['coin_899', 'coin_900', 'coin_901', 'coin_902'],
      },
      {
        title: 'coin_896',
        text: ['coin_903', 'coin_904', 'coin_905', 'coin_906'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/an-in-depth-look-at-the-shiba-inu-ecosystem/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2022/03/integration-137CR_LQ.png',
        imageAlt: 'Shiba Inu (SHIB) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Shiba Inu (SHIB) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-platform-coinrabbit/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Shiba Inu (SHIB) review 7',
      },
    ],
  },
}
